import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { FC } from '../../../Services/FeathersClient'

/**
 * Accesso al servizio `importDati` di BusinessAI, proxy verso l'Executor: i dataset (rotte
 * aeree, città GeoNames) stanno nel suo database, e il lavoro lo fa lui.
 */

const SERVIZIO = 'importDati'
const CHIAVE = ['importDati']

/**
 * Stato dei dataset e storico degli import. Si rilegge ogni 3 secondi mentre un import gira
 * (lo scraping delle rotte dura ore, e la pagina ne mostra l'avanzamento), ogni 30 altrimenti.
 */
export const useImportDati = () =>
  useQuery({
    queryKey: CHIAVE,
    queryFn: () => FC.service(SERVIZIO).find({}),
    refetchInterval: (query) =>
      (query.state.data?.tipi ?? []).some((tipo) => tipo.inCorso) ? 3000 : 30000,
    retry: false
  })

const useAzione = (esegui) => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: esegui,
    onSettled: () => client.invalidateQueries({ queryKey: CHIAVE })
  })
}

/** Avvia subito l'import di un tipo. */
export const useAvviaImport = () => useAzione((tipo) => FC.service(SERVIZIO).create({ tipo }))

/** Ferma l'import in corso di un tipo. */
export const useFermaImport = () =>
  useAzione((tipo) => FC.service(SERVIZIO).patch(tipo, { azione: 'ferma' }))

/** Accende, spegne o cambia la frequenza dell'import pianificato. */
export const usePianifica = () =>
  useAzione(({ tipo, attiva, ogniGiorni }) =>
    FC.service(SERVIZIO).patch(tipo, { azione: 'pianifica', attiva, ogniGiorni })
  )
